/**
 * Created by RSchweber-Koren on 4/11/2017.
 */

import angular from "angular";

import Assert from "tbAssert";
import TbAppConfigDataServiceModule from "../../config/tb-app-config/TbAppConfigDataService";

import TrackingTarget from "../TrackingTarget";
import CandidateElection from "../CandidateElection";
import Recipient from "../Recipient";

const mTbServerBaseUrl = new WeakMap();

class TrackingTargetFactory {
    constructor(TbAppConfigDataService) {
        Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");
        mTbServerBaseUrl.set(this, TbAppConfigDataService.tbServerBaseUrl);
    }

    Create(trackingTargetId, firstName, lastName, tgtCandidateElections, tgtSubscribers) {
        return new TrackingTarget(
            trackingTargetId,
            firstName,
            lastName,
            tgtCandidateElections,
            tgtSubscribers,
            mTbServerBaseUrl.get(this)
        );
    }

    CopyTarget(otherTarget) {
        let nTarget = new TrackingTarget(
            otherTarget.trackingTargetId,
            otherTarget.firstName,
            otherTarget.lastName,
            otherTarget.targetElections,
            otherTarget.subscribers,
            mTbServerBaseUrl.get(this)
        );

        return nTarget;
    }

    FromServerTrackingTarget(serverTrackingTarget) {

        let sTgtCElections = [];
        if (angular.isDefined(serverTrackingTarget["Elections"])) {
            sTgtCElections =
                serverTrackingTarget.Elections.map(function(cElection) {
                    return CandidateElection
                        .FromServerCandidateElection(
                            serverTrackingTarget.TrackingTargetId,
                            cElection);
                });
        }

        let sTgtSubscribers = [];
        if ((angular.isDefined(serverTrackingTarget["Subscribers"])) &&
            (serverTrackingTarget["Subscribers"] != null)) {

            sTgtSubscribers =
                serverTrackingTarget.Subscribers.map(function (rpt) {
                    return Recipient.FromServerRecipient(rpt);
                });
        }

        let sTgt = new TrackingTarget(
            serverTrackingTarget.TrackingTargetId,
            serverTrackingTarget.FirstName,
            serverTrackingTarget.LastName,
            sTgtCElections,
            sTgtSubscribers,
            mTbServerBaseUrl.get(this)
        );

        sTgt.detailsLocation =
            serverTrackingTarget.Links
                                .filter(function(link) {
                                    return (link.Rel === "details");
                                })
                                .map(function(link) {
                                    return link.Href;
                                })[0]; //should assign undefined if no detail link present.

        return sTgt;
    }
}

TrackingTargetFactory.$inject = [
    "TbAppConfigDataService"
];

export default angular
    .module("trackerbase-app.models.factories.tracking-target-factory",[
        TbAppConfigDataServiceModule
    ])
    .service("TrackingTargetFactory", TrackingTargetFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/models/factories/TrackingTargetFactory.js
// module id = 874s
// module chunks = 1